import { styled } from "@mui/system";
import Box from "@mui/material/Box";

export const InputContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
